import { useFieldState } from './useFieldState.js';

/* ----------------------- useScope ----------------------- */
function useSubState(sub) {
  return useFieldState(sub, false);
}

export { useSubState };
